<template>
  <v-dialog
    v-model="isVisibleWindow"
    scrollable
    max-width="1000"
    max-height="90%"
    min-width="90%"
  >
    <v-card>
      <v-card-actions>
        <h3 class="pl-2">
          {{ $t("windowFastOrder.title") }}
        </h3>
        <v-spacer></v-spacer>
        <v-btn icon @click="hideWin">
          <v-icon>fa-times</v-icon>
        </v-btn>
      </v-card-actions>
      <v-divider></v-divider>
      <v-card-text class="py-2">
        <h3>{{ $t("windowFastOrder.check_in") }}</h3>
        <v-form ref="check_in">
          <v-text-field
            outlined
            v-model="data.check_in.mileage"
            :label="$t('common.mileage')"
            :rules="[
              (v) => !!v || $t('form.validationErrors.field_is_required'),
              (v) => v >= 1 || $t('form.validationErrors.must_be_greater', [0]),
            ]"
          ></v-text-field>
          <v-text-field
            outlined
            append-icon="mdi-calendar"
            readonly
            :label="$t('windowFastOrder.last_maintenance_date')"
            @click="isVisibleDatepickerDialog = true"
            v-model="data.check_in.last_maintenance_date"
            :rules="[
              (v) => !!v || $t('form.validationErrors.field_is_required'),
            ]"
          >
          </v-text-field>
          <v-dialog
            ref="dialog"
            v-model="isVisibleDatepickerDialog"
            persistent
            width="290px"
          >
            <v-date-picker
              v-model="data.check_in.last_maintenance_date"
              :locale="locale"
              :first-day-of-week="first_day_of_week"
              scrollable
            >
              <v-spacer></v-spacer>
              <v-btn
                text
                color="primary"
                @click="isVisibleDatepickerDialog = false"
              >
                {{ $t("common.cancel") }}
              </v-btn>
              <v-btn text color="primary" @click="setDateFromDatepicker()">
                OK
              </v-btn>
            </v-date-picker>
          </v-dialog>

          <v-text-field
            outlined
            v-model="data.check_in.mileage_from_last_maintenance_date"
            :label="$t('windowFastOrder.mileage_from_last_maintenance_date')"
            :rules="[
              (v) => !!v || $t('form.validationErrors.field_is_required'),
              (v) => v >= 1 || $t('form.validationErrors.must_be_greater', [0]),
            ]"
          ></v-text-field>
        </v-form>
        <h3>{{ $t("common.customer") }}</h3>
        <template v-if="data.customer.id">
          <strong
            >{{ data.customer.last_name }} {{ data.customer.first_name }}
            {{ data.customer.patronymic }} ({{ data.customer.phone }})</strong
          >
          <v-btn
            icon
            color="warning"
            @click="
              data.customer = { id: null };
              data.car = {};
            "
            class=""
          >
            <v-icon>fa-times</v-icon>
          </v-btn>
        </template>
        <template v-if="!data.customer.id">
          <v-form ref="customer">
            <v-text-field
              outlined
              v-model="data.customer.phone"
              :label="$t('common.phone')"
              :rules="[
                (v) => !!v || $t('form.validationErrors.field_is_required'),
              ]"
            ></v-text-field>

            <v-text-field
              outlined
              v-model="data.customer.last_name"
              :label="$t('common.last_name')"
              :rules="[
                (v) => !!v || $t('form.validationErrors.field_is_required'),
              ]"
            ></v-text-field>
            <v-text-field
              outlined
              v-model="data.customer.first_name"
              :label="$t('common.first_name')"
            ></v-text-field>
            <v-text-field
              outlined
              v-model="data.customer.patronymic"
              :label="$t('common.patronymic')"
              hide-details
            ></v-text-field>
          </v-form>
          <v-btn
            elevation="0"
            color="primary"
            class="mb-5 mt-2"
            @click="isVisibleCustomerFindForm = !isVisibleCustomerFindForm"
          >
            {{ $t("windowFastOrder.choose_exist_customer") }}
          </v-btn>
        </template>
        <h3>{{ $t("common.car") }}</h3>
        <div v-show="!data.car.name">
          <template
            v-if="
              data.customer &&
              data.customer.id != null &&
              data.customer.cars.length
            "
          >
            <car-selector-from-list
              :list="data.customer.cars"
              @selected="(data) => selectCar(data)"
            ></car-selector-from-list>
            <h4>{{ $t("windowFastOrder.new_car") }}</h4>
          </template>
          <car-selector-by-api
            v-show="isVisible"
            :visibility-status.sync="isVisible"
            @selected="(data) => selectCar(data)"
          />
        </div>
        <strong v-if="data.car.name">
          <span v-if="data.car.name === ''">
            {{ data.car.brand }} {{ data.car.model }}</span
          >
          <span v-else> {{ data.car.name }}</span>
          <span v-if="data.car.vin"> VIN: {{ data.car.vin }}</span>
          <beauty-car-number
            class="d-inline-block ml-2"
            :number="data.car.car_number ? data.car.car_number : ''"
          />
          <v-btn icon color="warning" @click="data.car = {}" class="">
            <v-icon>fa-times</v-icon>
          </v-btn>
        </strong>
      </v-card-text>
      <v-divider class=""></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="white--text" elevation="0" color="red" @click="hideWin"  :disabled="savingInProgress" :loading="savingInProgress">
          {{ $t("common.cancel") }}
        </v-btn>
        <v-btn color="primary" elevation="0" @click="store" :disabled="savingInProgress" :loading="savingInProgress">
          {{ $t("common.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="isVisibleCustomerFindForm" scrollable max-width="500">
      <customerFindForm
        @select="
          (customer) => {
            this.data.customer = customer;
            this.isVisibleCustomerFindForm = false;
          }
        "
        :visible="isVisibleCustomerFindForm"
      ></customerFindForm>
    </v-dialog>
  </v-dialog>
</template>

<script>
//import CarSelectorByApi from "../common/CarSelectorByApi";
import CustomerFindForm from "@/components/customer/CustomerFindForm";
import CarSelectorFromList from "../common/CarSelectorFromList";
import BeautyCarNumber from "@/components/common/BeautyCarNumber";
import { mapFields } from "vuex-map-fields";
import CommonMixin from "@/mixins/common";
export default {
  name: "FastOrderWindow",
  mixins: [CommonMixin],
  components: {
    BeautyCarNumber,
    CarSelectorFromList,
    CustomerFindForm,
    //CarSelectorByApi,
    CarSelectorByApi: () => import("@/components/common/CarSelectorByApi.vue"),
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isVisibleDatepickerDialog: false,
    isVisibleCustomerFindForm: false,
    data: {
      check_in: {
        mileage: null,
      },
      customer: {
        id: null,
      },
      car: {},
    },
  }),
  computed: {
    ...mapFields("orders", ["savingInProgress"]),
    isVisibleWindow: {
      get() {
        return this.isVisible;
      },
      set() {
        this.$emit("hide");
      },
    },
  },
  methods: {
    hideWin() {
      this.isVisibleWindow = false;
      this.data.check_in = {};
      this.data.customer = {};
      this.data.car = {};
      if (this.$refs["check_in"]) this.$refs["check_in"].reset();
      if (this.$refs["customer"]) this.$refs["customer"].reset();
    },
    setDateFromDatepicker() {
      this.isVisibleDatepickerDialog = false;
    },
    store() {
      let isValid = this.$refs["check_in"].validate();
      if (!this.data.customer.id) {
        isValid = this.$refs["customer"].validate();
      }
      if (isValid && !this.data.car.car_number) {
        isValid = false;

        this.$error(this.$t("windowFastOrder.error_no_car_selected"));
      }
      if (isValid) {
        this.$store
          .dispatch("orders/fastOrderStore", this.data)
          .then((humanNumber) => {
            this.hideWin();
            this.$emit('search', humanNumber)
          });
      }
    },
    selectCar(car) {
      if (!car.vin) {
        this.$error(this.$t("windowFastOrder.error_no_car_vin"));
        return;
      }
      if (!car.car_number) {
        this.$error(this.$t("windowFastOrder.error_no_car_number"));
        return;
      }
      this.data.car = car;
    },
  },
};
</script>

<style scoped></style>
